import HPImg from '../../assets/HarryPotterCategoryImage.jpg';
import GOTImg from '../../assets/GOTCategoryImage.jpg';
export const quizQues = [
    {
        categoryId: "1",
        category: "Harry Potter",
        categoryImg: HPImg,
        categoryDesc: "Get your thinking spells ready!",
        questions: [
            {
                question: "Harrys uncle and aunt, the Dursleys,live at what address?",
                answer: 'Number 4, Privet Drive',
                options: [
                    {
                        option: "Number 4, Privet Drive",
                    },
                    {
                        option: "Nine and three-quarters",
                    },
                    {
                        option: "The trolls club",
                    },
                    {
                        option: "Gringotts",
                    },
                ],
            },
            {
                question: "Hermiones parents are not wizards.What non-wizard jobs do they do?",
                answer: 'Dentists',
                options: [
                    {
                        option: "Physician",
                    },
                    {
                        option: "Tailor",
                    },
                    {
                        option: "Dentists",
                    },
                    {
                        option: "Mechanic",
                    },
                ],
            },
            {
                question: "How old was Voldemort when he the Chamber of Secrets?",
                answer: '16 years',
                options: [
                    {
                        option: "15 years",
                    },
                    {
                        option: "16 years",
                    },
                    {
                        option: "17 years",
                    },
                    {
                        option: "18 years",
                    },
                ],
            },
            {
                question: "In Harry Potter and the Stone, who reports the commentary for Quidditch matches at Hogwarts?",
                answer: 'Lee Jordan',
                options: [
                    {
                        option: "Albus Dumbledore",
                    },
                    {
                        option: "Mrs Norris",
                    },
                    {
                        option: "Lee Jordan",
                    },
                    {
                        option: "Professor Sprout",
                    },
                ],
            },
            {
                question: "On a Quidditch pitch, how many goal posts are there in total?",
                answer: 'Six',
                options: [
                    {
                        option: "Four",
                    },
                    {
                        option: "Five",
                    },
                    {
                        option: "Six",
                    },
                    {
                        option: "Seven",
                    },
                ],
            },
        ]
    },
    {
        categoryId: "2",
        category: "Game Of Thrones",
        categoryImg: GOTImg,
        categoryDesc: "You Win or You Die!",
        questions: [
            {
                question: "Which of the following was Sansa never married or engaged to?",
                answer: 'Loras Tyrell',
                options: [
                    {
                        option: "Tyrion Lannister",
                    },
                    {
                        option: "Loras Tyrell",
                    },
                    {
                        option: "Joffrey Baratheon",
                    },
                    {
                        option: "Ramsay Bolton",
                    },
                ],
            },
            {
                question: "What is the sigil of house Baratheon?",
                answer: 'Stag',
                options: [
                    {
                        option: "Stag",
                    },
                    {
                        option: "Wolf",
                    },
                    {
                        option: "Unicorn",
                    },
                    {
                        option: "Goat",
                    },
                ],
            },
            {
                question: "Where would you find the Citadel, the headquarters of the order of the maesters?",
                answer: 'Oldtown',
                options: [
                    {
                        option: "Braavos",
                    },
                    {
                        option: "Lannisport",
                    },
                    {
                        option: "Oldtown",
                    },
                    {
                        option: "Qarth",
                    },
                ],
            },
            {
                question: "Which of these characters never served as hand to a king (or queen)?",
                answer: 'Jorah Mormont',
                options: [
                    {
                        option: "Ned Stark",
                    },
                    {
                        option: "Tyrion Lannister",
                    },
                    {
                        option: "Ser Davos Seaworth",
                    },
                    {
                        option: "Jorah Mormont",
                    },
                ],
            },
            {
                question: "In what real-life city were many King's Landing scenes filmed?",
                answer: 'Dubrovnik',
                options: [
                    {
                        option: "Chicago",
                    },
                    {
                        option: "Edinburgh",
                    },
                    {
                        option: "Rome",
                    },
                    {
                        option: "Dubrovnik",
                    },
                ],
            },
        ]
    }
]